import Video from './Video'
import { Gender } from './Gender'

import { VideoProps } from '@src/quince-components/src'
import Image from './Image'

interface IProductVideoOption {
  readonly name: string
  readonly values: string[]
}

export class ProductVideoOption implements IProductVideoOption {
  readonly name: string
  readonly values: string[]

  constructor({ name, values }: IProductVideoOption) {
    this.name = name
    this.values = values
    return {
      ...this,
    }
  }
}

interface IProductVideo {
  readonly video: Video
  readonly options: ProductVideoOption[]
  readonly videoIndex?: number
  readonly gender?: Gender | undefined
  readonly videoPoster?: Image
}

export default class ProductVideo implements IProductVideo {
  readonly video: Video
  // This tells for what all options this video is applicable
  readonly options: ProductVideoOption[]
  readonly gender: Gender | undefined
  readonly videoIndex?: number
  readonly videoPoster?: Image

  constructor({ video, options, gender = undefined, videoIndex = undefined, videoPoster = undefined }: IProductVideo) {
    this.video = video
    this.options = options
    this.gender = gender
    this.videoIndex = videoIndex
    this.videoPoster = videoPoster
    return {
      ...this,
    }
  }

  static makeVideoProps(productVideo?: ProductVideo): VideoProps {
    if (productVideo === undefined) {
      return {
        url: '',
        id: '',
      }
    }
    return Video.makeVideoProps(productVideo.video)
  }
}
